import store from '@/state/store'
const fields = [
  {
    key: 'createdOn',
    label: 'global.field.date',
    header: 'date',
    filter: false,
    width: 20,
    disabled: true,
  },
  {
    key: 'vehicle',
    label: 'report.fields.licensePlate',
    header: 'licensePlate',
    filter: true,
    width: 20,
  },
  {
    key: 'vehicleType',
    label: 'report.fields.vehicleType',
    header: 'vehicleType',
    filter: false,
    width: 30,
  },
  {
    key: 'sensorType',
    label: 'report.fields.sensorType',
    header: 'sensorType',
    filter: false,
    width: 20,
  },
  {
    key: 'fuel',
    label: 'report.fields.fuel',
    header: 'fuel',
    filter: false,
    width: 10,
  },
  {
    key: 'fuelPercentage',
    label: 'report.fields.fuelPercentage',
    header: 'fuelPercentage',
    filter: false,
    width: 10,
    disabled: false,
  },
  {
    key: 'speed',
    label: 'report.fields.speed',
    header: 'speed',
    filter: false,
    width: 10,
    disabled: false,
    formatter: (value) => {
      return value ? value : 0
    },
  },
  {
    key: 'acc',
    label: 'report.object.acc',
    header: 'acc',
    filter: false,
    width: 10,
  },
  {
    key: 'address',
    label: 'report.fields.location',
    header: 'address',
    filter: false,
    width: 10,
    formatter: (value) => {
      return value ? value : '-'
    },
  },
]
if (store.getters['identity/hasAccess'](['fuel_geofence_column:read'])) {
  fields.splice(8, 0, {
    key: 'geofence',
    label: 'report.fields.geolocation',
    header: 'geofence',
    filter: false,
    width: 30,
  })
}
export default fields
